import React from "react";
import {NavLink} from "react-router-dom";
import axios from 'axios'
import Cache from '@aws-amplify/cache';
import Dropdown from 'react-bootstrap/Dropdown'
import { toast } from 'react-toastify';

export class Header extends React.Component {

    logout() {
      Cache.clear()
      window.location.replace('/')
    }

    switchAccount() {
      axios.post('/user/switch', {
        supplierID: this.props.user.linkedAccount
      })
      .then(data => {
        if (data.token) {
          Cache.setItem('supplier_auth_token', data.token)
          window.location.replace('/')
        }
      })
      .catch(err => {
        console.error(err)
        toast.error('Failed to switch account')
      })
    }

    render() {
        return (
          <nav className="navbar navbar-dark fixed-top bg-dark flex-md-nowrap p-0">
            <NavLink to={"/dashboard"} className="navbar-brand col-md-2 mr-0">
              <button className="navbar-toggler mr-2 d-md-none d-lg-none" type="button" onClick={this.props.toggleSidebar}>
                <span className="navbar-toggler-icon"></span>
              </button>
              <img src="/logo.png" height="27" width="166"/>
            </NavLink>
            <ul className="navbar-nav px-3 d-none d-md-block">
              <Dropdown>
                <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                  {this.props.user.name}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {this.props.user.linkedAccount ? 
                  <>
                  <Dropdown.Item onClick={this.switchAccount.bind(this)}>{this.props.user.linkedAccountName}</Dropdown.Item>
                  <Dropdown.Divider />
                  </> : null}
                  <Dropdown.Item onClick={this.logout}>Sign out</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </ul>
          </nav>
        );
    }
}
